import { createAction } from 'redux-starter-kit';


export const putNotifications = createAction('PUT_NOTIFICATIONS');
export const putNotification = createAction('PUT_NOTIFICATION');
export const removeNotification = createAction('REMOVE_NOTIFICATION');
